import {idleEnhancer} from './idle'

export const enhancers = [
    idleEnhancer,
]
